import {contentExistInPanels, usePanelManager} from '@tritt/multipanel'
import {CREATE_TRANSACTION} from '@/transaction/create-transaction'
import {IncomingDocument} from '@/types/IncomingDocument'
import {useAttachDocumentService} from '@/transaction/create-transaction/AttachDocument.service'

export const useTaskManager = () => {
    const {setPanelPath} = usePanelManager()
    const {isDocumentAttached, attachDocument, detachDocument} = useAttachDocumentService()

    const panelAwareToggleDocumentAttach = async (document: IncomingDocument) => {
        const uuid = document.documentMeta.uuid

        if (!isDocumentAttached(uuid)) {
            if(!contentExistInPanels(CREATE_TRANSACTION.componentName)) {
                await setPanelPath({
                    ...CREATE_TRANSACTION,
                    panelId: 2
                })
            }
            await attachDocument(document)
        } else {
            detachDocument(document)
        }
    }

    return {
       panelAwareToggleDocumentAttach
    }
}

